import { render, staticRenderFns } from "./MarkContainer.vue?vue&type=template&id=3f8bead8&scoped=true&"
import script from "./MarkContainer.vue?vue&type=script&lang=js&"
export * from "./MarkContainer.vue?vue&type=script&lang=js&"
import style0 from "./MarkContainer.vue?vue&type=style&index=0&id=3f8bead8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8bead8",
  null
  
)

export default component.exports